module.exports = __webpack_public_path__ + "static/media/profile_icon.0f51c9a3.svg";